import { styled, TextField, Typography } from '@mui/material';

export const TextAreaLabel = styled(Typography)({
    fontSize: '17px',
    fontWeight: 600,
});

export const TextArea = styled(TextField)({
    '&, .MuiInputBase-root, textarea': {
        height: '100%!important',
        width: '100%!important',
    },
    '& .MuiInputBase-root': {
        borderRadius: '12px',
        background:
            'linear-gradient(171deg, rgba(58, 98, 227, 0.18) 0%, rgba(89, 184, 202, 0.18) 100%)',
        boxShadow: '9px 8px 41px 0px rgba(0, 0, 0, 0.59)',
    },
    '& .MuiInputBase-input': {
        fontSize: '20px',
        fontWeight: 500,
    },
    '& fieldset': {
        border: 'none',
    },
});
